import { render, staticRenderFns } from "./HotelInquiry.vue?vue&type=template&id=53758462&scoped=true"
import script from "./HotelInquiry.vue?vue&type=script&lang=js"
export * from "./HotelInquiry.vue?vue&type=script&lang=js"
import style0 from "./HotelInquiry.vue?vue&type=style&index=0&id=53758462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53758462",
  null
  
)

export default component.exports